import React from 'react';
import ChatIcon from '../Icons/ChatIcon';
import RightArrow from '../Icons/RightArrow';
import Badge from '../Badge';

const ChatHomeButton = ({
  icon: Icon = ChatIcon,
  label = 'Start a new conversation',
  onClick,
  className = '',
  disabled = false,
  loading = false,
  visible = true,
  numberBadge = 0,
  config,
  ...props
}) => {
  if (!visible) return null;

  const handleButtonClick = () => {
    if (disabled || loading) return;
    if (onClick) {
      onClick();
    }
  };

  // Helper to check if icon is a string and a link (http/https or data url)
  const isIconUrl = typeof Icon === 'string' && (
    Icon.startsWith('http://') ||
    Icon.startsWith('https://') ||
    Icon.startsWith('data:')
  );

  return (
    <button
      onClick={handleButtonClick}
      disabled={disabled || loading}
      className={`
        bubble-home-button
        flex
        w-full
        p-v3-sm
        items-center
        gap-v3-xs
        rounded-[20px]
        bg-white
        shadow-v3-double
        transition-all
        duration-200
        shadow-v3-shadow-double
        text-[var(--element-color)]
        hover:shadow-none
        hover:!text-[var(--brand-color)]
        disabled:opacity-50
        disabled:cursor-not-allowed
        disabled:hover:border-transparent
        disabled:hover:text-inherit
        z-10
        ${className}
      `}
      style={{
        '--brand-color': config?.brand_color || 'var(--v3-purple-primary)',
        '--element-color': config?.element_color || 'var(--v3-black-max)',
        backgroundColor: config?.surface_color || '#ffffff',
      }}
      {...props}
    >
      {Icon && (
        isIconUrl ? (
          <img src={Icon} className="flex-shrink-0" alt="icon" />
        ) : (
          // If Icon is a React component, render it
          typeof Icon === 'function' ? (
            <Icon className="flex-shrink-0 text-[var(--brand-color)]" />
          ) : null
        )
      )}
      <span
        className="bubble-home-button-label flex-1 text-left font-medium break-words max-w-[320px]"
        style={{
          fontFamily: config?.font_name ? `${config.font_name}, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif` : undefined,
          fontSize: config?.font_size ? `${config.font_size}px` : undefined,
        }}
      >
        {loading ? 'Loading...' : label}
      </span>
      {numberBadge > 0 ? <Badge>{numberBadge}</Badge>: <RightArrow className="flex-shrink-0" style={{ color: config?.brand_color || 'var(--v3-purple-primary)' }} />}
    </button>
  );
};

export default ChatHomeButton;
